export default [
  {
    path: "/app/profile",
    component: () => import("../index.vue"),
    meta: {
      title: "Educasis - Perfil",
      requiresAuth: true
    },
    children: [
      {
        path: "",
        name: "user.profile",
        component: () => import("../views/Profile.vue")
      }
    ]
  }
];
